import { TagGroups } from "@/types/search";
import { Recipe, Recipes } from "@/types/recipes";
import { getRecipeImage } from "@/utils/search-util";
import { SelectingIngredientListDataItem, Products } from "@/types/common";
import DateUtil from "@/utils/date-util";
import NativeClient from "@/client/native-client";
import PantryUtil from "@/utils/pantry-util";
import { COMMON_LIMIT_NUM } from "@/const/limit_const";

export const PANTRY_SORT_TYPE = {
  SHORT_EXPIRED: "shortexpired",
  OLD_DAY: "oldest",
  NEW_DAY: "newest"
};

export const PANTRY_FOOD_TYPE = {
  USER: "user",
  PLATE: "plate",
  FRIDGE: "fridge"
};
export const MAX_FRIDGE_ROOM = 4;
export const FRIDGE_ROOM_ID_TYPE = {
  FRIDGE: 0,
  FREEZER: 1,
  VEGETABLE: 2,
  DOOR: 3
};

export const FRIDGE_INFO_ROOM_ID_TYPE = {
  FRIDGE_INFO_FRIDGE: 0,
  FRIDGE_INFO_FREEZER: 1,
  FRIDGE_INFO_VEGETABLE: 2
}

// 冷蔵室
export const FRIDGE_AREA_ID_TYPE = {
  // 左ドア
  LEFT_DOOR: 0,
  // 正面棚
  FRONT_SHELF: 1,
  // 右ドア
  RIGHT_DOOR: 2,
  // チルド室
  CHILLED_ROOM: 3,
  // 切り出し画像
  CUTOUT_IMAGE: 4
};

// 冷凍室
export const FREEZER_AREA_ID_TYPE = {
  // 上トレイ
  UPPER_TRAY: 0,
  // 中トレイ
  MEDIAM_TRAY: 1,
  // 下トレイ
  LOWER_TRAY: 2,
  // 上トレイ（右）
  UPPER_RIGHT_TRAY: 3,
  // 上トレイ（左）
  UPPER_LEFT_TRAY: 4
};

// 野菜室
export const VEGETABLE_AREA_ID_TYPE = {
  // 上トレイ
  UPPER_TRAY: 0,
  // 中トレイ
  MEDIAM_TRAY: 1,
  // 下トレイ
  LOWER_TRAY: 2,
  // 下トレイ（ポケット）
  LOWER_POCKET_TRAY: 3
};

export const FRIDGE_INFO_DOOR_ID_TYPE = {
  // 両開きドア （左:40% 右:60%)
  FRENCH_DOOR: 0,
  //右開きドア
  RIGHT_OPEN_DOOR: 1,
  // 左開きドア
  LEFT_OPEN_DOOR: 2
};

export const FRIDGE_IMAGE_LIST = [
  FRIDGE_AREA_ID_TYPE.FRONT_SHELF
];

export const DOOR_FRENCH_IMAGE_LIST = [
  FRIDGE_AREA_ID_TYPE.LEFT_DOOR,
  FRIDGE_AREA_ID_TYPE.RIGHT_DOOR
];

export const DOOR_RIGHT_IMAGE_LIST = [
  FRIDGE_AREA_ID_TYPE.RIGHT_DOOR
];

export const DOOR_LEFT_IMAGE_LIST = [
  FRIDGE_AREA_ID_TYPE.LEFT_DOOR
];

export const VEGETABLE_IMAGE_LIST = [
  VEGETABLE_AREA_ID_TYPE.UPPER_TRAY,
  VEGETABLE_AREA_ID_TYPE.LOWER_TRAY,
  VEGETABLE_AREA_ID_TYPE.LOWER_POCKET_TRAY
];

export const FREEZER_IMAGE_LIST = [
  FREEZER_AREA_ID_TYPE.UPPER_LEFT_TRAY,
  FREEZER_AREA_ID_TYPE.UPPER_RIGHT_TRAY,
  FREEZER_AREA_ID_TYPE.UPPER_TRAY,
  FREEZER_AREA_ID_TYPE.MEDIAM_TRAY,
  FREEZER_AREA_ID_TYPE.LOWER_TRAY
];


export const IMAGE_ORIENTATION_TYPE = {
  HORIZONTAL: 0,
  VERTICAL: 1
};

export const PLATE_SELECT_DATE_TYPE = {
  NONE: 0,
  DATE: 1
};

export const PLATE_STOCK_NOTIFICATION_TYPE = {
  // 残量変化時
  STOCK_CHANGE: 0,
  // 残量
  STOCK_LOW: 1,
  // 毎日
  EVERY_DAY: 2,
  // 通知なし
  NONE: -1
};

export const PLATE_DISPLAY_FORMAT = {
  VALUE: 0,
  GAUGE: 1
};

export const PLATE_DELETE_FOOD_STATUS = {
  NONE: 0, // その他
  THREW_AWAY: 1, // 捨てた
  USED: 2 // 使い切った
};

export const PLATE_DATE_SETTING = {
  DATE: 0,
  NOTIFICATION: 1
};

export const NETWORK_TIMING = {
  NORMAL: 0,
  ENERGY_SAVING: 1
};

export const INTERNAL_MODE = {
  ALL_TIME_CONNECT_MODE: 0
};

export const DETAIL_ITEM_TYPE = {
  PURCHASE_DATE: 0,
  STOCK_QUANTITY: 1,
  EXPIRATION_DATE: 2,
  STORAGE: 3,
  NOTIFICATION: 4,
  STOCK_NOTIFICATION: 5
};

export const DETAIL_ITEM_DATA = {
  PURCHASE_DATE: "入庫日",
  STOCK_QUANTITY_PLATE: "数量（個数/%）",
  STOCK_QUANTITY: "残量",
  EXPIRATION_DATE: "期限目安",
  STORAGE: "保存場所",
  NOTIFICATION: "使い忘れ通知",
  STOCK_NOTIFICATION: "残量通知"
};

export const DETAIL_ITEM_TITLE = {
  PURCHASE_DATE: "入庫日設定",
  STOCK_QUANTITY: "残量設定",
  EXPIRATION_DATE: "期限目安設定",
  STORAGE: "保存場所設定",
  NOTIFICATION: "使い忘れ通知設定",
  STOCK_NOTIFICATION: "残量通知設定"
};

export const PANTRY_STORAGE_TYPE = {
  ALL: "指定なし",
  REFRIGERATOR: "冷蔵庫",
  STORAGE: "収納庫",
  DISASTER_PREVENTION: "防災"
};

export const PANTRY_SERVER_STORAGE_TYPE = {
  COLD: "cold",
  CHILLED: "chilled",
  PARTIAL: "partial",
  VEGETABLE: "vegetable",
  VEGETABLE_UPPER: "vegetableUpper",
  VEGETABLE_LOWER: "vegetableLower",
  FREEZER: "freezing",
  COOL_AND_DARK_ROOM: "cool",
  NORMAL_TEMPERATURE: "room"
};

export const PANTRY_NEW_STORAGE_TYPE = {
  REFRIGERATOR: "冷蔵室",
  CHILLED: "チルド",
  PARTIAL: "パーシャル",
  VEGETABLE: "野菜室",
  FREEZER: "冷凍室",
  COOL_AND_DARK_ROOM: "冷暗所",
  NORMAL_TEMPERATURE: "常温"
};

export const PANTRY_NEW_STORAGE_ID = {
  REFRIGERATOR: 0,
  CHILLED: 1,
  PARTIAL: 2,
  VEGETABLE: 3,
  FREEZER: 4,
  COOL_AND_DARK_ROOM: 5,
  NORMAL_TEMPERATURE: 6
};

export const PANTRY_SERVER_STORAGE_TYPE_TABLE = [
  {serverType: PANTRY_SERVER_STORAGE_TYPE.COLD, type: PANTRY_NEW_STORAGE_TYPE.REFRIGERATOR},
  {serverType: PANTRY_SERVER_STORAGE_TYPE.CHILLED, type: PANTRY_NEW_STORAGE_TYPE.CHILLED},
  {serverType: PANTRY_SERVER_STORAGE_TYPE.PARTIAL, type: PANTRY_NEW_STORAGE_TYPE.PARTIAL},
  {serverType: PANTRY_SERVER_STORAGE_TYPE.VEGETABLE, type: PANTRY_NEW_STORAGE_TYPE.VEGETABLE},
  {serverType: PANTRY_SERVER_STORAGE_TYPE.VEGETABLE_UPPER, type: PANTRY_NEW_STORAGE_TYPE.VEGETABLE},
  {serverType: PANTRY_SERVER_STORAGE_TYPE.VEGETABLE_LOWER, type: PANTRY_NEW_STORAGE_TYPE.VEGETABLE},
  {serverType: PANTRY_SERVER_STORAGE_TYPE.FREEZER, type: PANTRY_NEW_STORAGE_TYPE.FREEZER},
  {serverType: PANTRY_SERVER_STORAGE_TYPE.COOL_AND_DARK_ROOM, type: PANTRY_NEW_STORAGE_TYPE.COOL_AND_DARK_ROOM},
  {serverType: PANTRY_SERVER_STORAGE_TYPE.NORMAL_TEMPERATURE, type: PANTRY_NEW_STORAGE_TYPE.NORMAL_TEMPERATURE}
 ];

export const PANTRY_STORAGE_TYPE_TABLE = [
  {id: PANTRY_NEW_STORAGE_ID.REFRIGERATOR, type: PANTRY_NEW_STORAGE_TYPE.REFRIGERATOR},
  {id: PANTRY_NEW_STORAGE_ID.CHILLED, type: PANTRY_NEW_STORAGE_TYPE.CHILLED},
  {id: PANTRY_NEW_STORAGE_ID.PARTIAL, type: PANTRY_NEW_STORAGE_TYPE.PARTIAL},
  {id: PANTRY_NEW_STORAGE_ID.VEGETABLE, type: PANTRY_NEW_STORAGE_TYPE.VEGETABLE},
  {id: PANTRY_NEW_STORAGE_ID.FREEZER, type: PANTRY_NEW_STORAGE_TYPE.FREEZER},
  {id: PANTRY_NEW_STORAGE_ID.COOL_AND_DARK_ROOM, type: PANTRY_NEW_STORAGE_TYPE.COOL_AND_DARK_ROOM},
  {id: PANTRY_NEW_STORAGE_ID.NORMAL_TEMPERATURE, type: PANTRY_NEW_STORAGE_TYPE.NORMAL_TEMPERATURE}
]

export const PANTRY_DEFAULT_STORAGE_TYPE = PANTRY_NEW_STORAGE_TYPE.REFRIGERATOR;
export const PANTRY_DEFAULT_STORAGE_ID = PANTRY_NEW_STORAGE_ID.REFRIGERATOR;

export const PANTRY_STRING = {
  PANTRY_NONE_SETTING: "指定なし",
  PANTRY_NONE_NOTIFICATION: "通知なし",
  PANTRY_PLATE_STOCK_CHANGE: "残量変化時"
};

export const PANTRY_STORAGE_ID = {
  ALL: 0,
  REFRIGERATOR: 1,
  STORAGE: 2,
  DISASTER_PREVENTION: 3
};

export const PANTRY_ADD_CATEGORY_TYPE = {
  // カメラ
  CAMERA: 0,
  // 購入済み
  PURCHASED: 1,
  // お気に入り
  FAVORITE: 2,
  // よく使う
  RANKING: 3,
  // その他
  OTHER: 10000
};

export const PANTRY_ADD_CATEGORY_NAME_TYPE = {
  // カメラ
  CAMERA: "カメラ",
  // 購入済み
  PURCHASED: "買い物",
  // お気に入り
  FAVORITE: "お気に入り",
  // よく使う
  RANKING: "よく使う",
};


/** パントリレシピ種別 */
export const PANTRY_RECIPE_TYPE = {
  /** 人気レシピ */
  RECOMMEND: "pantry_recommend"
} as const;

export const ERROR_STATUS_CODE_SUCCESS = "0";
export const ALL_TIME_CONNECT_MODE = 0;
export const DEFALT_FOOD_ID = -1;
export const SEARCH_VIEW_SMALL_HEIGHT_RAITO = 0.55;
export const REM_VIRTUAL_LIST_PADDING = 2.1;
export const REM_VIRTUAL_LIST_FOOD_PADDING = 1.7;
export const REGISTER_FOOD_STOCK_QUANTITY = 100;
// TODO:サーバーレスポンス対応まで冷凍室2段、うまもりで返却
export const CAMERA_ROOM_FREEZER_TRAY = 2;
export const CAMERA_ROOM_VEGITABLE_TRAY = 3;

export class DateValueInfo {
  date: string | null;
  defaultDate: string | null;
  minDate: string | null;
  maxDate: string | null;
  valueType: number;
  itemType: number;
  constructor() {
    this.date = "";
    this.defaultDate = null;
    this.minDate = null;
    this.maxDate = null;
    this.valueType = PLATE_DATE_SETTING.DATE;
    this.itemType = -1;
  }
}

export const CONFIRM_USER_NEW = {
  USER_NEW: 1,
  USER_ALREADY_EXISTS: 0
}

export interface RootState {
  version: string;
}

export interface PantryState {
  // タグ
  tagGroups: TagGroups | null;
  // レシピ検索
  searchRecipes: Recipes | null;
  // おすすめ パントリー詳細
  recommendRecipes: Recipes | null;
  // パントリー新一覧取得
  pantryList: PantryList | null;
  // パントリー新一覧取得
  pantryVirtualList: PantryList | null;
  // パントリー詳細情報取得
  pantryDetail: PantryDetail | null;
  // パントリー重量検知プレート食材詳細情報
  pantryPlateDetail: PantryPlateDetail | null;
  // パントリー消費済み食材一覧取得
  pantryConsumeFoods: PantryConsumeFoods | null;
  // パントリー：重量検知プレート積載食材残量経過取得
  pantryPlateSettingWeight: PantryPlateSettingWeightInfo | null;
  // パントリー：庫内情報取得
  pantryFridgeListInfo: PantryFridgeListInfo | null;
  // パントリー：冷蔵庫食材認識修正候補取得
  recognitionCandidateMap: RecognitionCandidateMap | null;
  // パントリー：冷蔵庫食材詳細取得
  pantryFridgeDetail: PantryFridgeDetail | null;
  // 食品一覧検索API
  recipeFoods: RecipeFoods | null;
  recipeFoodMap: RecipeFoodMap | null;
  // パントリー新一覧取得
  usedUpPantryList: PantryList | null;
  // ユーザー食品利用ランキング取得API
  rankingFoods: RankingFoods | null;
  // お気に入り食品(一覧取得)API
  favotiteFoods: FavoriteFoods | null;
  // シーン別カテゴリー一覧取得API
  menuCategoies: MenuCategories | null;
  // 購入済み食材リスト取得
  purChasedFoods: PurChasedFoods | null;
  // 登録済み機器一覧取得
  products: Products | null;
  // プレート設定取得
  plateDeviceMode: PlateDeviceMode | null;
  // 食品提案
  foodRecommendationList: FoodRecommendationList | null;
  // パントリー消費済み食材一覧取得
  foodConsumeList: PantryItemsConsumeFoodList | null;
  // お気に入り食品状態API
  favoriteFoodStatus: FavoriteFoodStatus | null;
  // パントリー：冷蔵庫食材判定
  fridgeItemsJudge: FridgeItemsJudge | null;
  // 食材追加情報
  addFoodItems: SaveAddFoodItemData | null;
  // 食材削除情報
  deleteFoodItems: SaveDeleteFoodItemData | null;
  // カメラ画像保存用
  cameraImageMap: CameraImageMap | null;
  // カメラ画像URL保存用
  cameraImageUrlMap: CameraImageUrlMap | null;
}

export class CameraImageItem {
  key: string;
  applianceId: string;
  imageUrlFileName: string;
  imageData: string | null;
  constructor(item: RequstCameraImage, imageData: string | null) {
    this.key = item.key;
    this.applianceId = item.applianceId;
    this.imageUrlFileName = item.imageUrlFileName;
    this.imageData = imageData;
  }
}

export class CameraImageMap {
  map: Map<string, CameraImageItem>;
  constructor() {
    this.map = new Map();
  }
}

export class CameraImageUrlItem {
  key: string;
  imageUrl: string;
  constructor(key: string, imageUrl: string) {
    this.key = key;
    this.imageUrl = imageUrl;
  }
}

export class CameraImageUrlMap {
  map: Map<string, CameraImageUrlItem>;
  constructor() {
    this.map = new Map();
  }
}

export class RequstCameraImage {
  key: string;
  imageUrl: string;
  imageUrlFileName: string;
  applianceId: string;
  constructor(imageUrl: string, imageUrlFileName: string, applianceId: string) {
    this.key = applianceId + "_" + imageUrlFileName;
    this.imageUrl = imageUrl;
    this.imageUrlFileName = imageUrlFileName;
    this.applianceId = applianceId;
  }
}

export class PantryVirtualData {
  image: string | null;
  info: PantryListInfo | null;
  checked: boolean;
  constructor(image: string | null, info: PantryListInfo | null) {
    this.image = image;
    this.info = info;
    this.checked = false;
  }
  isEquals = (info: PantryListInfo) => {
    if (this.info == null) {
      return false;
    }
    if (info == null) {
      return false;
    }
    if (info.pantryId != null && this.info.pantryId != null && info.pantryId == this.info.pantryId) {
      return true;
    } else if (info.pantryPlateId != null && this.info.pantryPlateId != null && info.pantryPlateId == this.info.pantryPlateId) {
      return true;
    } else if (info.pantryFridgeId != null && this.info.pantryFridgeId != null && info.pantryFridgeId == this.info.pantryFridgeId) {
      return true;
    }
    return false;
  }

  isEqualsFoodItem = (info: FoodItem) => {
    if (this.info == null) {
      return false;
    }
    if (info == null) {
      return false;
    }
    if (info.pantryId != null && this.info.pantryId != null && info.pantryId == this.info.pantryId) {
      return true;
    } else if (info.pantryPlateId != null && this.info.pantryPlateId != null && info.pantryPlateId == this.info.pantryPlateId) {
      return true;
    } else if (info.pantryFridgeId != null && this.info.pantryFridgeId != null && info.pantryFridgeId == this.info.pantryFridgeId) {
      return true;
    }
    return false;
  }
}

export class PantryVirtualInfo {
  list: Array<PantryVirtualData>;
  constructor() {
    this.list = new Array<PantryVirtualData>();
  }
}

export class PantryVirtualDataInfo {
  id: number;
  data: PantryVirtualData;
  value: number;
  constructor(id: number, data: PantryVirtualData, value: number) {
    this.id = id;
    this.data = data;
    this.value = value;
  }
}

export class PantryVirtualLineInfo {
  id: number;
  is3rows: boolean;
  list: Array<PantryVirtualDataInfo>;
  constructor(id: number, is3rows: boolean, list: Array<PantryVirtualDataInfo>) {
    this.id = id;
    this.is3rows = is3rows;
    this.list = list;
  }
}

export class PantrySelectData {
  id: number;
  image: string;
  constructor(id: number, image: string) {
    this.id = id;
    this.image = image;
  }
}

// パントリー更新日時取得
export class PantryLastUpdate {
  lastUpdated: string;
  constructor() {
    this.lastUpdated = "";
  }
}

export class UsedUpPantryItem {
  id: number;
  info: FridgeJudgeItem;
  foodStatus: number;
  constructor(id: number, info: FridgeJudgeItem) {
    this.id = id;
    this.info = info;
    this.foodStatus = PLATE_DELETE_FOOD_STATUS.NONE;
  }
  equals(data: UsedUpPantryItem) {
    return (data && data.id == this.id);
  }
}

export class UsedUpPantryList {
  list: Array<UsedUpPantryItem> | null;
  constructor() {
    this.list = null;
  }
}

// パントリー新一覧取得
export class RequestPantryList {
  order: string;
  start: number;
  row: number;
  constructor(order: string, start: number, row: number) {
    this.order = order;
    this.start = start;
    this.row = row;
  }
}

export class PantryList {
  pantryList: Array<PantryListInfo>;
  lastUpdated: string;
  totalCount: number;
  start: number;
  constructor() {
    this.pantryList = [];
    this.lastUpdated = "";
    this.totalCount = 0;
    this.start = 0;
  }
}

export interface PantryListInfo {
  pantryId: number;
  pantryPlateId: number;
  pantryFridgeId: number;
  ingredientId: number;
  name: string;
  imageUrl: string | null;
  icon: string;
  purchaseDate: string | null;
  notificationDate: string | null;
  expirationDate: string | null;
  calcExpirationDate: string;
  storageType: string | null;
  roomId: number;
  areaId: number;
  stockQuantity: number;
  createDate: string;
  favoriteStatus: boolean;
  hasItem: boolean;
  plate: PantryPlateInfo;
  applianceId: string | null;
}

export class PantryPlateInfoData {
  info: PantryPlateInfo;
  constructor(info: PantryPlateInfo) {
    this.info = info;
  }
}

interface PantryPlateInfo {
  name: string;
  status: number;
  errorStatus: PantryPlateErrorStatus;
  battery: number;
  unit: PantryPlateUnitInfo;
  item: PantryPlateItemInfo;
}

interface PantryPlateErrorStatus {
  errorCode: string;
  errorMessage: string;
}

interface PantryPlateUnitInfo {
  displayFormat: number;
  fullWeight: number;
  unitWeight: number;
  update: string;
}

interface PantryPlateItemInfo {
  value: number;
  update: string;
}

// パントリー登録（食材選択・手入力）
export class RegisterPantryInfo {
  ingredientId: number;
  manualIngredient: string;
  purchaseDate: string | null;
  notificationDate: string | null;
  expirationDate: string | null;
  storageType: string;
  stockQuantity: number;
  constructor(
    ingredientId: number,
    manualIngredient: string,
    purchaseDate: string | null,
    notificationDate: string | null,
    expirationDate: string | null,
    stockQuantity: number
  ) {
    this.ingredientId = ingredientId;
    this.manualIngredient = manualIngredient;
    this.purchaseDate = purchaseDate;
    this.notificationDate = notificationDate;
    this.expirationDate = expirationDate;
    this.storageType = "";
    this.stockQuantity = stockQuantity;
  }
}

export class PantryPlateSettingWeightData {
  info: PantryPlateSettingWeightInfo;
  constructor(info: PantryPlateSettingWeightInfo) {
    this.info = info;
  }
}

export class PlateInfoData {
  data: PantryPlateDetailPlateInfo | null;
  plate: PlateDeviceModeInfo | null;
  weight: PantryPlateSettingWeightData | null;
  constructor(data: PantryPlateDetailPlateInfo | null, mode: PlateDeviceMode | null, weight: PantryPlateSettingWeightInfo | null) {
    this.data = data;
    if (mode) {
      this.plate = mode.plate;
    } else {
      this.plate = null;
    }
    if (weight) {
      this.weight = new PantryPlateSettingWeightData(weight);
    } else {
      this.weight = null;
    } 
  }
}

export class PantryDetailInfo {
  user: PantryDetail | null;
  plate: PantryPlateDetail | null;
  fridge: PantryFridgeDetail | null;
  updateUser: UpdatePantryInfo | null;
  updatePlate: UpdatePantryPlateInfo | null;
  updateFridge: UpdatePantryFridgeInfo | null;
  plateData: PlateInfoData | null;

  constructor() {
    this.user = null;
    this.plate = null;
    this.fridge = null;
    this.updateUser = null;
    this.updatePlate = null;
    this.updateFridge = null;
    this.plateData = null;
  }
  setUser(user: PantryDetail | null, updateUser: UpdatePantryInfo | null) {
    this.user = user;
    this.updateUser = updateUser;
  }
  setPlate(plate: PantryPlateDetail | null, updatePlate: UpdatePantryPlateInfo | null, mode: PlateDeviceMode, weight: PantryPlateSettingWeightInfo) {
    this.plate = plate;
    this.updatePlate = updatePlate;
    if (plate != null && plate.plate != null && mode != null && weight != null) {
      this.plateData = new PlateInfoData(plate.plate, mode, weight);
    }
  }
  setFridge(fridge: PantryFridgeDetail | null, updateFridge: UpdatePantryFridgeInfo | null) {
    this.fridge = fridge;
    this.updateFridge = updateFridge;
  }
}

// パントリー詳細情報取得
export interface PantryDetail {
  pantryId: number;
  ingredientId: number;
  janCode: string;
  name: string;
  imageUrl: string | null;
  purchaseDate: string | null;
  notificationDate: string | null;
  expirationDate: string | null;
  calcExpirationDate: string;
  storageType: string;
  stockQuantity: number;
  createDate: string;
  favoriteStatus: boolean;
}

// パントリー更新
export class UpdatePantryInfo {
  purchaseDate: string | null;
  expirationDate: string | null;
  notificationDate: string | null;
  storageType: string | null;
  stockQuantity: number | null;
  constructor() {
    this.purchaseDate = null;
    this.expirationDate = null;
    this.notificationDate = null;
    this.storageType = null;
    this.stockQuantity = null;
  }
  setPantryDetail(data: PantryDetail) {
    this.purchaseDate = data.purchaseDate;
    this.notificationDate = data.notificationDate;
    this.expirationDate = data.expirationDate;
    this.storageType = data.storageType;
    this.stockQuantity = data.stockQuantity;
  }
  set(purchaseDate: string | null, expirationDate: string | null,  notificationDate: string | null, storageType: string | null, stockQuantity: number | null) {
    this.purchaseDate = purchaseDate;
    this.expirationDate = expirationDate;
    this.notificationDate = notificationDate;
    this.storageType = storageType;
    this.stockQuantity = stockQuantity;
  }
}

// パントリー削除
export class DeletePantryInfo {
  pantryList: Array<DetetePantryItem>;
  pantryPlateList: Array<DetetePantryPlateItem>;
  pantryFridgeList: Array<DetetePantryFridgeItem>;
  constructor() {
    this.pantryList = [];
    this.pantryPlateList = [];
    this.pantryFridgeList = [];
  }
}

export class DetetePantryItem {
  pantryId: number;
  foodStatus: number | null;
  constructor(pantryId: number, foodStatus: number | null) {
    this.pantryId = pantryId;
    this.foodStatus = foodStatus;
  }
}

export class DetetePantryPlateItem {
  pantryPlateId: number;
  foodStatus: number | null;
  constructor(pantryPlateId: number, foodStatus: number | null) {
    this.pantryPlateId = pantryPlateId;
    this.foodStatus = foodStatus;
  }
}

export class DetetePantryFridgeItem {
  pantryFridgeId: number;
  foodStatus: number | null;
  constructor(pantryFridgeId: number, foodStatus: number | null) {
    this.pantryFridgeId = pantryFridgeId;
    this.foodStatus = foodStatus;
  }
}

// パントリー登録
export class RegisterFood {
  ingredientId: number | null;
  manualIngredient: string | null;
  purchaseDate: string | null;
  notificationDate: string | null;
  expirationDate: string | null;
  storageType: string | null;
  stockQuantity: number;

  constructor() {
    this.ingredientId = null;
    this.manualIngredient = null;
    this.purchaseDate = "";
    this.notificationDate = "";
    this.expirationDate = "";
    this.storageType = null;
    this.stockQuantity = REGISTER_FOOD_STOCK_QUANTITY;
  }

  setFoodId(ingredientId: number, purchaseDate: string, expirationDate: string | null, storageType: string | null) {
    this.ingredientId = ingredientId;
    this.purchaseDate = purchaseDate;
    this.expirationDate = expirationDate;
    this.storageType = storageType;
  }

  setManual(manualIngredient: string, purchaseDate: string) {
    this.manualIngredient = manualIngredient;
    this.purchaseDate = purchaseDate;
    this.storageType = PANTRY_DEFAULT_STORAGE_TYPE;
  }
}

// パントリーScan登録（食材）
export class RegisterScanIngredients {
  pantryList: Array<RegisterScanIngredient>;
  constructor(pantryList: Array<RegisterScanIngredient>) {
    this.pantryList = pantryList;
  }
}

export class RegisterScanIngredient {
  ingredientId: number;
  purchaseDate: string;
  expirationDays: number | null;
  storageType: string | null;
  constructor(ingredientId: number, purchaseDate: string, expirationDays: number | null) {
    this.ingredientId = ingredientId;
    this.purchaseDate = purchaseDate;
    this.expirationDays = expirationDays;
    this.storageType = null;
  }
}

// パントリー消費済み食材一覧取得
export class RequstPantryConsumeFoods {
  lastdate: string;
  start: number;
  constructor(lastdate: string, start: number) {
    this.lastdate = lastdate;
    this.start = start;
  }
}

export interface PantryConsumeFoods {
  pantryList: Array<PantryConsumeFood>;
  totalCount: number;
  start: number;
}

export interface PantryConsumeFood {
  pantryId: number;
  pantryPlateId: number;
  pantryFridgeId: number;
  ingredientId: number;
  name: string;
  imageUrl: string;
}

// パントリー重量検知プレート食材詳細情報
export class RequstPantryPlateDetail {
  pantryPlateId: number | null;
  applianceId: string | null;
  constructor(pantryPlateId: number | null, applianceId: string | null) {
    if (pantryPlateId == -1) {
      this.pantryPlateId = null;
    } else {
      this.pantryPlateId = pantryPlateId;
    }
    if (applianceId == "") {
      this.applianceId = null;
    } else {
      this.applianceId = applianceId;
    }
  }
}

export class StockQuantityInfo {
  value: number;
  plate: PlateStockQuantityInfo | null;
  constructor() {
    this.value = 0;
    this.plate = null;
  }
}

export class PlateStockQuantityInfo {
  displayFormat: number;
  constructor(plate: PantryPlateDetailPlateInfo) {
    if (plate != null && plate.unit != null) {
      this.displayFormat = plate.unit.displayFormat;
    } else {
      this.displayFormat = -1;
    }
  }
}

export interface PantryPlateDetail {
  pantryPlateId: number;
  applianceId: string;
  ingredientId: number;
  janCode: string;
  name: string;
  imageUrl: string | null;
  purchaseDate: string | null;
  notificationDate: string | null;
  expirationDate: string;
  calcExpirationDate: string;
  storageType: string;
  createDate: string;
  favoriteStatus: boolean;
  plate: PantryPlateDetailPlateInfo;
}

export interface PantryPlateDetailPlateInfo {
  caseId: number;
  name: string;
  correction: PantryPlateCorrectionInfo;
  network: PantryPlateTimeInfo;
  remaining: PantryPlateTimeInfo;
  battery: number;
  unit: PantryPlateUnitInfo;
  errorStatus: PantryPlateErrorStatus;
  thresholdCount: number;
  item: PantryPlateItemInfo;
}

export interface PantryPlateCorrectionInfo {
  value: number;
  update: string;
}

export class PantryPlateTimeInfo {
  timing: number;
  time: number | null;
  constructor(timing: number, time: number | null) {
    this.timing = timing;
    this.time = time;
  }
}

// パントリー重量検知プレート食材詳細登録
export class RegisterPantryPlateInfo {
  applianceId: string;
  ingredientId: number;
  manualIngredient: string;
  purchaseDate: string | null;
  notificationDate: string | null;
  expirationDate: string | null;
  calcExpirationDate: string;
  storageType: string;
  createDate: string;
  plate: RegisterPantryPlatePlateInfo;
  constructor(
    applianceId: string,
    ingredientId: number,
    manualIngredient: string,
    purchaseDate: string,
    notificationDate: string,
    expirationDate: string,
    calcExpirationDate: string,
    storageType: string,
    createDate: string,
    plate: RegisterPantryPlatePlateInfo
  ) {
    this.applianceId = applianceId;
    this.ingredientId = ingredientId;
    this.manualIngredient = manualIngredient;
    this.purchaseDate = purchaseDate;
    this.notificationDate = notificationDate;
    this.expirationDate = expirationDate;
    this.calcExpirationDate = calcExpirationDate;
    this.storageType = storageType;
    this.createDate = createDate;
    this.plate = plate;
  }
}

export class RegisterPantryPlatePlateInfo {
  remaining: PantryPlateTimeInfo;
  thresholdCount: number;
  constructor(
    data: PantryPlateDetailPlateInfo
  ) {
    this.remaining = data.remaining;
    this.thresholdCount = data.thresholdCount;
  }
}

// パントリー重量検知プレート食材詳細更新
export class UpdatePantryPlateInfo {
  purchaseDate: string | null;
  expirationDate: string | null;
  notificationDate: string | null;
  storageType: string | null;
  plate: RegisterPantryPlatePlateInfo | null;
  constructor(data: PantryPlateDetail) {
    this.purchaseDate = data.purchaseDate;
    this.notificationDate = data.notificationDate;
    this.expirationDate = data.expirationDate;
    this.storageType = data.storageType;
    this.plate = new RegisterPantryPlatePlateInfo(data.plate);
  }
  set(purchaseDate: string | null, expirationDate: string | null, notificationDate: string | null, storageType: string | null, plate: RegisterPantryPlatePlateInfo | null) {
    this.purchaseDate = purchaseDate;
    this.expirationDate = expirationDate;
    this.notificationDate = notificationDate;
    this.storageType = storageType;
    this.plate = plate;
  }
}

// パントリー：重量検知プレート積載食材残量経過取得
export class RequstPantryPlateSettingWeight {
  pantryPlateId: number | null;
  applianceId: string;
  startdate: string;
  enddate: string;
  constructor(pantryPlateId: number | null, applianceId: string, startdate: string, enddate: string) {
    this.pantryPlateId = pantryPlateId;
    this.applianceId = applianceId;
    this.startdate = startdate;
    this.enddate = enddate;
  }
}

export interface PantryPlateSettingWeightInfo {
  unit: PantryPlateWeightUnitInfo;
  maxValue: number;
  weights: Array<PantryPlateWeightInfo>;
}

export interface PantryPlateWeightUnitInfo {
  displayFormat: number;
  fullWeight: number;
  update: string;
}

export interface PantryPlateWeightInfo {
  datetime: string;
  weight: number;
  correction: PantryPlateWeightCorretionInfo;
}

export interface PantryPlateWeightCorretionInfo {
  value: number;
}

export class PantryFridgeDummyRoomData {
  roomId: number;
  images: Array<PantryFridgeImageData>;
  constructor(roomId: number, images: Array<PantryFridgeImageData>) {
    this.roomId = roomId;
    this.images = images;
  }
};

export class PantryFridgeAreaImageInfo {
  roomId: number;
  areaId: number;
  orientation: number;
  marginTop: string;
  marginBottom: string;
  marginLeft: string;
  marginRight: string;
  totalSize: number;
  position: number;

  constructor(image: PantryFridgeImageData) {
    this.roomId = image.roomId;
    this.areaId = image.areaId;
    this.orientation = image.orientation;
    this.marginTop = image.marginTop;
    this.marginBottom = image.marginBottom;
    this.marginLeft = image.marginLeft;
    this.marginRight = image.marginRight;
    this.totalSize = image.totalSize;
    this.position = image.position;
  }
}

export class PantryFridgeAreaImageData {
  position: number;
  // areaIdに対して1個のイメージ情報を保持する
  imageInfo: PantryFridgeAreaImageInfo;
  // areaIdに対して該当するイメージ情報を保持する
  images: Array<PantryFridgeImageData>;
  constructor(image: PantryFridgeImageData, images: Array<PantryFridgeImageData>) {
    this.position = 0;
    this.imageInfo = new PantryFridgeAreaImageInfo(image);
    this.images = images;
  }
  getSelectImage() {
    let image = null;
    if (this.images.length > this.position) {
      image = this.images[this.position];
    }
    return image;
  }
}

export class PantryFridgeRoomData {
  roomId: number;
  areaMap: Map<number, PantryFridgeAreaImageData>;
  constructor(roomId: number, imageMap: Map<number, Array<PantryFridgeImageData>>, areaImageMap: Map<number, PantryFridgeImageData>) {
    this.roomId = roomId;
    this.areaMap = new Map();
    for (const key of areaImageMap.keys()) {
      const imageData = areaImageMap.get(key);
      const imageMapData = imageMap.get(key);
      if (imageData != undefined && imageMapData != undefined) {
        const areaImage = new PantryFridgeAreaImageData(imageData, imageMapData);
        this.areaMap.set(key, areaImage);
      }
    }
  }
  getImageList() {
    const images = new Array<PantryFridgeImageData>();
    for (const key of this.areaMap.keys()) {
      const data = this.areaMap.get(key);
      if (data != null) {
        const image = data.getSelectImage();
        if (image != null) {
          images.push(image);
        }
      }
    }
    return images;
  }
}

export class PantryFridgeRoomCreateData {
  roomId: number;
  images: Array<PantryFridgeImageData>;
  constructor(roomId: number, images: Array<PantryFridgeImageData>) {
    this.roomId = roomId;
    this.images = images;
  }
}


export class PantryFridgeImageData {
  id: number;
  roomId: number;
  areaId: number;
  info: PantryFridgeImageInfo | null;
  dataUrl: string;
  imageData: string | null;
  marginTop: string;
  marginBottom: string;
  marginLeft: string;
  marginRight: string;
  totalSize: number;
  imageUrlFilePath: string;
  position: number;
  applianceId: string | null;
  orientation: number;
  key: string;
  constructor(id: number, roomId: number, info: PantryFridgeImageInfo | null, applianceId: string | null) {
    this.id = id;
    this.roomId = roomId;
    this.info = info;
    this.dataUrl = "";
    this.imageData = null;
    this.marginTop = "0rem";
    this.marginBottom = "0rem";
    this.marginLeft = "0rem";
    this.marginRight = "0rem";
    this.totalSize = 0;
    let imageUrlFileName = "";
    if (info && info.imageUrl) {
      imageUrlFileName = PantryUtil.getImageUrlFilePath(info.imageUrl);
    }
    if (info) {
      this.areaId = info.areaId;
    } else {
      this.areaId = -1;
    }
    this.imageUrlFilePath = imageUrlFileName;
    this.position = 0;
    this.applianceId = applianceId;
    this.orientation = IMAGE_ORIENTATION_TYPE.VERTICAL;
    this.key = this.applianceId + "_" + imageUrlFileName;
  }
}

// パントリー：庫内情報取得
export interface PantryFridgeListInfo {
  rooms: Array<PantryFridgeRoomInfo>;
  reizoDoorTypeId: number;
  // 野菜室トレイ数
  numOfVegetableShelves: number;
  // 冷凍室うまもり
  isUmamori: boolean;
  // 冷凍室トレイ数
  numOfFreezerShelves: number;
}

export interface PantryFridgeRoomInfo {
  roomId: number;
  images: Array<PantryFridgeImageInfo>;
}

export interface PantryFridgeImageInfo {
  devicePhotoImageId: number;
  imageUrl: string;
  vertical: number;
  horizontal: number;
  capturedTime: string;
  areaId: number;
  opticalAxis: number;
}

// 庫内画像ルーム情報
export class FridgeCameraRoomInfo {
  reizoDoorTypeId: number;
  numOfVegetableShelves: number;
  isUmamori: boolean;
  numOfFreezerShelves: number;
  constructor() {
    this.reizoDoorTypeId = FRIDGE_INFO_DOOR_ID_TYPE.FRENCH_DOOR;
    this.numOfVegetableShelves = CAMERA_ROOM_VEGITABLE_TRAY;
    this.isUmamori = true;
    this.numOfFreezerShelves = CAMERA_ROOM_FREEZER_TRAY;
  }
};

// パントリー：冷蔵庫食材認識修正候補取得
export interface RecognitionCandidateInfo {
  inferenceResultFoodId: number;
  devicePhotoImageId: number;
  imageUrl: string;
  capturedTime: string;
  vertical: number;
  horizontal: number;
  roomId: number;
  areaId: number;
  ingredientId: number;
  ingredientImageUrl: string;
  name: string;
  leftTopX: number;
  leftTopY: number,
  rightBottomX: number;
  rightBottomY: number;
  candidates: Array<CandidateInfo>;
}

export class CandidateInfo {
  ingredientId: number;
  name: string;
  imageUrl: string;
  userNew: number;
  constructor() {
    this.ingredientId = -1;
    this.name = "";
    this.imageUrl = "";
    this.userNew = CONFIRM_USER_NEW.USER_NEW;
  }
}

// パントリー：冷蔵庫食材認識修正候補更新
export class UpdatePantryFridgeRecognitionInfo {
  ingredientId: number;
  constructor(ingredientId: number) {
    this.ingredientId = ingredientId;
  }
}

// パントリー：認識食材一覧取得
export interface PantryFridgeRecognitionList {
  items: Array<PantryFridgeRecognitionListInfo>;
}

export interface PantryFridgeRecognitionListInfo {
  objectId: number;
  pantryFridgeId: number;
  applianceId: string;
  ingredientId: number;
  name: string;
  imageUrl: string;
  icon: string;
  pantryAdded: boolean;
}

// パントリー：冷蔵庫食材登録
export class RegisterPantryFridgeList {
  objects: Array<RegisterPantryFridge>;
  constructor(objects: Array<RegisterPantryFridge>) {
    this.objects = objects;
  }
}

export class RegisterPantryFridge {
  objectId: number;
  constructor(objectId: number) {
    this.objectId = objectId;
  }
}

// パントリー：冷蔵庫食材更新
export class UpdatePantryFridgeInfo {
  purchaseDate: string | null;
  expirationDate: string | null;
  notificationDate: string | null;
  // TODO:数量は仮
  stockQuantity: number | null;
  constructor() {
    this.purchaseDate = null;
    this.expirationDate = null;
    this.notificationDate = null;
    this.stockQuantity = null;
  }
  setPantryFridgeDetail(data: PantryFridgeDetail) {
    this.purchaseDate = data.purchaseDate;
    this.notificationDate = data.notificationDate;
    this.expirationDate = data.expirationDate;
    this.stockQuantity = data.stockQuantity;
  }
  set(purchaseDate: string | null, expirationDate: string | null, notificationDate: string | null, stockQuantity: number | null) {
    this.purchaseDate = purchaseDate;
    this.expirationDate = expirationDate;
    this.notificationDate = notificationDate;
    this.stockQuantity = stockQuantity;
  }
}

// パントリー：冷蔵庫食材詳細情報取得
export interface PantryFridgeDetail {
  pantryFridgeId: number;
  ingredientId: number;
  name: string;
  imageUrl: string | null;
  purchaseDate: string;
  notificationDate: string;
  expirationDate: string;
  calcExpirationDate: string;
  roomId: number;
  updateDate: string;
  createDate: string;
  stockQuantity: number;
  favoriteStatus: boolean;
}

export class PantrySearchLineInfo {
  id: number;
  list: Array<PantrySearchItemInfo>
  constructor(id: number, list:  Array<PantrySearchItemInfo>) {
    this.id = id;
    this.list = list;
  }
}

export class PantrySearchItemInfo {
  id: number;
  imageUrl: string;
  name: string;
  recipeId: number;
  type: string;
  constructor(id: number, recipe: Recipe | null) {
    this.id = id;
    this.imageUrl = "";
    this.name = "";
    this.recipeId = -1;
    this.type = "";
    if (recipe != null) {
      this.imageUrl = "";
      if (recipe.images != null && recipe.images.length != 0) {
        this.imageUrl = getRecipeImage(recipe.images[0]);
      } 
      this.name = recipe.title;
      this.recipeId = recipe.recipeId;
      this.type = recipe.type;
    }
  }
}

export class FoodTipData {
  id: number;
  title: string;
  tip: ShelfLifeTips | null;
  constructor(id: number, title: string, tip: ShelfLifeTips | null) {
    this.id = id;
    this.title = title;
    this.tip = tip;
  }
}

const SHELF_LIVE_DEFAULT = 1;
export class RecipeFoodItemInfo {
  item: RecipeFoodItem;
  constructor(item: RecipeFoodItem) {
    this.item = item;
  }

  getFoodShelfLive = () => {
    let result = null;
    if (this.item && this.item.shelfLives) {
      for (const item of this.item.shelfLives) {
        if (item.default == SHELF_LIVE_DEFAULT) {
          result = item;
          break;
        }
      }
    }
    return result;
  }
}

// 食品一覧検索API
export class RequestRecipeFoods {
  ids: Array<number>;
  constructor() {
    this.ids = [];
  }
  getIdsString = () => {
    let result = "";
    for (const id of this.ids) {
      if (result != "") {
        result += " ";
      }
      result += id;
    }
    return result;
  }
}


export class RecipeFoodsData {
  foodItem: RecipeFoodItem | null;
  constructor(foodItem: RecipeFoodItem | null) {
    this.foodItem = foodItem;
  }
}

export class RecipeFoodMap {
  map: Map<number, RecipeFoodItem>;
  constructor(foodItem: RecipeFoods | null) {
    if (foodItem == null) {
      this.map = new Map<number, RecipeFoodItem>();
    } else {
      this.map = new Map<number, RecipeFoodItem>();
      for (const item of foodItem.foods) {
        this.map.set(item.foodId, item)
      }
    }
  }
  getDefineShelfLive(foodId: number) {
    NativeClient.sendDebugLog("getDefineExpirationDay foodId=" + foodId)
    let result = null;
    const item = this.map.get(foodId);
    if (item != null) {
      for (const shelfLive of item.shelfLives) {
        if (shelfLive.default == 1) {
          NativeClient.sendDebugLog("getDefineExpirationDay foodId=" + foodId + " shelfLive.shelfType=" + shelfLive.shelfType)
          result = shelfLive;
        }
      }
    }
    return result;
  }
  getShelfTypeShelfLive(foodId: number, shelfType: string) {
    NativeClient.sendDebugLog("getShelfTypeExpirationDay foodId=" + foodId + " shelfType=" + shelfType);
    let result = null;
    const item = this.map.get(foodId);
    if (item != null) {
      for (const shelfLive of item.shelfLives) {
        if (shelfLive.shelfType == shelfType) {
          NativeClient.sendDebugLog("getShelfTypeExpirationDay foodId=" + foodId + " shelfType=" + shelfType + " shelfLive=" + JSON.stringify(shelfLive));
          result = shelfLive;
        }
      }
    }
    return result;
  }
}

export interface RecipeFoods {
  foods: Array<RecipeFoodItem>;
  totalCount: number;
  start: number;
}

export interface RecipeFoodItem {
  foodId: number;
  name: string;
  class: string;
  category: string;
  description: string;
  image: string;
  icon: string;
  balances: Balance;
  banners: Array<FoodBanner>;
  shelfLives: Array<FoodShelfLive>;
  tips: Array<FoodTip>;
  refIndexDef: number;
}

export interface Balance {
  name: string;
  value: string;
  color: string;
}

export class FoodBanner {
  image: string;
  link: string;
  constructor(image: string, link: string) {
    this.image = image;
    this.link = link;
  }
}

export interface FoodShelfLive {
  description: string;
  comment: string;
  tips: ShelfLifeTips;
  shelfLife: number;
  shelfType: string;
  shelfTypeName: string;
  default: number;
}

export class ShelfLifeTips {
  image: string | null;
  description: string;
  constructor(image: string | null, description: string) {
    this.image = image;
    this.description = description;
  }
}

export interface FoodTip {
  image: string;
  description: string;
  shelfType: string;
  shelfTypeName: string;
}
export class FoodItem {
  name: string;
  icon: string | null;
  foodId: number;
  recipeFoodItem: RecipeFoodItemInfo | null;
  pantryId: number;
  pantryPlateId: number;
  pantryFridgeId: number;
  timerId: number;
  inferenceResultFoodId: number;
  userNew: number;
  constructor(name: string, icon: string | null, foodId: number, foodItem: RecipeFoodItemInfo | null) {
    this.name = name;
    this.icon = icon;
    this.foodId = foodId;
    this.recipeFoodItem = foodItem;
    this.pantryId = -1;
    this.pantryPlateId = -1;
    this.pantryFridgeId = -1;
    this.timerId = DateUtil.getTodayMs();
    this.inferenceResultFoodId = DEFALT_FOOD_ID;
    this.userNew = CONFIRM_USER_NEW.USER_NEW;
  }
  isEqual(data: PantryVirtualData) {
    if (data == null || data.info == null) {
      return false;
    }
    const info = data.info;
    if (this.pantryId != null && info.pantryId != null && this.pantryId == info.pantryId) {
      return true;
    } else if (this.pantryPlateId != null && info.pantryPlateId != null && this.pantryPlateId == info.pantryPlateId) {
      return true;
    } else if (this.pantryFridgeId != null && info.pantryFridgeId != null && this.pantryFridgeId == info.pantryFridgeId) {
      return true;
    }
    return false;
  }
}

export class SearchFoodItem {
  id: number;
  food: FoodItem;
  constructor(id: number, food: FoodItem) {
    this.id = id;
    this.food = food;
  }
}

export class RequestPantryDetailSearch {
  keywords: string;
  foodIds: string;
  constructor(keywords: string, foodIds: string) {
    this.keywords = keywords;
    this.foodIds = foodIds;
  }
}

export class RequestPantrySearch {
  keywords: string;
  foodIds: string;
  targetAll: boolean;
  tags: string;
  start: number;
  rows: number;
  constructor(list: Array<SearchFoodItem>, targetAll: boolean, tags: string) {

    this.keywords = "";
    this.foodIds = "";
    for (const item of list) {
      if (this.keywords != "") {
        this.keywords += " ";
      }
      if (this.foodIds != "") {
        this.foodIds += " ";
      }
      if (item.food.foodId != -1 && item.food.foodId != null) {
        this.foodIds += item.food.foodId;
      } else {
        this.keywords += item.food.name;
      }
    }
    this.targetAll = targetAll;
    this.tags = tags;
    this.start = 0;
    this.rows = COMMON_LIMIT_NUM.PANTRY_LIST_RECIPE_SEARCH_FIRST_LIMIT;
  }

  set(start: number, rows: number) {
    this.start = start;
    this.rows = rows;
  }
}

export class RequestRecommendRecipe {
  keyword: string | null;
  foodId: number | null;
  constructor(keyword: string | null, foodId: number | null) {
    this.keyword = keyword;
    this.foodId = foodId;
  }
}

export class SearchTagItem {
  alias: string;
  id: number;
  constructor(alias: string, id: number) {
    this.alias = alias;
    this.id = id;
  }
}

// ユーザー食品利用ランキング取得API
export interface RankingFoods {
  foods: Array<RankingFood>;
}

export interface RankingFood {
  rank: number;
  foodId: number;
  category: string;
  name: string;
  image: string;
  icon: string;
}

// お気に入り食品(一覧取得)API
export interface FavoriteFoods {
  foods: Array<FavoriteFood>;
  totalCount: number;
  start: number;
}

export interface FavoriteFood {
  foodId: number;
  class: string;
  category: string;
  name: string;
  image: string;
  icon: string;
}

// シーン別カテゴリー一覧取得API
export interface MenuCategories {
  categories: Array<MenuCategory>;
}

export interface MenuCategory {
  id: number;
  name: string;
  note: string;
  image: string;
  aliasName: string;
  recipeCount: number;
  startDate: string;
  endDate: string;
  releaseDate: string;
  children: Array<MenuCategory>
}

// 購入済み食材リスト取得
export interface PurChasedFoods {
  foods: Array<PurChasedFood>;
  totalCount: number;
  start: number;
}

export interface PurChasedFood {
  id: number;
  foodId: number;
  name: string;
  iconUrl: string;
}

export class CategoryFood {
  name: string;
  foods: RecipeFoods;
  constructor(name: string, foods: RecipeFoods) {
    this.name = name;
    this.foods = foods;
  }
}

export class CategoryFoodList {
  list: Map<string, CategoryFood>;
  constructor() {
    this.list = new Map();
  }
}

export class RequestCategoryId {
  name: string;
  ids: string;
  constructor(name: string, ids: string) {
    this.name = name;
    this.ids = ids;
  }
}

export class AddCategoryItem {
  name: string;
  constructor(name: string) {
    this.name = name;
  }
}

export class AddCategoryList {
  list: Array<AddCategoryItem>;
  constructor() {
    this.list = [];
  }
}

export class PantryImageSelectData {
  id: number;
  name: string;
  constructor(id: number, name: string) {
    this.id = id;
    this.name = name;
  }
}

export class RecognitionCandidate {
  id: number | null;
  inferenceResultFoodId: number | null;
  info: RecognitionCandidateInfo | null;
  applianceId: string | null;
  foodImageUrl: string | null;
  imageData: string | null;
  imageUrlFileName: string | null;
  key: string | null; 
  userNew: number;
  constructor(id: number, inferenceResultFoodId: number | null, applianceId: string | null) {
    this.id = id;
    this.inferenceResultFoodId = inferenceResultFoodId;
    this.info = null;
    this.foodImageUrl = null;
    this.imageData = null;
    this.applianceId = applianceId;
    this.imageUrlFileName = null;
    this.key = null;
    this.userNew = CONFIRM_USER_NEW.USER_NEW;
  }
  set(info: RecognitionCandidateInfo) {
    this.info = info;
    this.foodImageUrl = "";
    this.imageData = null;
    const imageUrlFileName = PantryUtil.getImageUrlFilePath(info.imageUrl);
    this.imageUrlFileName = imageUrlFileName;
    this.key = this.applianceId + "_" + imageUrlFileName;
  }
}

export class RequestRecognitionCandidateItem {
  inferenceResultFoodId: number;
  applianceId: string;
  constructor(inferenceResultFoodId: number, applianceId: string) {
    this.applianceId = applianceId;
    this.inferenceResultFoodId = inferenceResultFoodId;
  }
}

export class PutRecognitionCandidate {
  ingredientId: number | null;
  userFixName: string | null;
  constructor(ingredientId: number | null, userFixName: string | null) {
    this.ingredientId = ingredientId;
    this.userFixName = userFixName;
  }
}

export class PutRecognitionCandidateRequest {
  objectId: number;
  data: PutRecognitionCandidate;
  constructor(objectId: number, data: PutRecognitionCandidate) {
    this.objectId = objectId;
    this.data = data;
  }
}

export class RecognitionCandidateMap {
  map: Map<number, RecognitionCandidate>;
  constructor() {
    this.map = new Map();
  }
}

export class IngredientData {
  title: string;
  list: Array<SelectingIngredientListDataItem>;
  constructor(title: string, list: Array<SelectingIngredientListDataItem>) {
    this.title = title;
    this.list = list;
  }
}

export class IngredientCategoryData {
  categoryName: string;
  list: Array<IngredientData>;
  constructor(categoryName: string, list: Array<IngredientData>) {
    this.categoryName = categoryName;
    this.list = list;
  }
}

export class RequestFavoriteFood {
  foodId: number;
  constructor(foodId: number) {
    this.foodId = foodId;
  }
}

export class RequestUpdateFoodData {
  pantryId: number;
  payload: UpdatePantryInfo;
  constructor(pantryId: number, payload: UpdatePantryInfo) {
    this.pantryId = pantryId;
    this.payload = payload;
  }
}

export class RequestUpdatePlateFoodData {
  pantryId: number;
  payload: UpdatePantryPlateInfo;
  constructor(pantryId: number, payload: UpdatePantryPlateInfo) {
    this.pantryId = pantryId;
    this.payload = payload;
  }
}

export class RequestUpdateFridgeFoodData {
  pantryId: number;
  payload: UpdatePantryFridgeInfo;
  constructor(pantryId: number, payload: UpdatePantryFridgeInfo) {
    this.pantryId = pantryId;
    this.payload = payload;
  }
}

// 購入済み食材リスト取得
export interface PlateDeviceMode {
  plate: PlateDeviceModeInfo;
}

export interface PlateDeviceModeInfo {
  initial: boolean;
  caseId: number;
  name: string;
  correction: PantryPlateCorrectionInfo;
  network: PantryPlateTimeInfo;
  remaining: PantryPlateTimeInfo;
  unit: PantryPlateUnitInfo;
  errorStatus: PantryPlateErrorStatus;
  temperature: number;
  thresholdDay: number;
  thresholdCount: number;
  weightCapacityUpper: number;
  weightCapacityLower: number;
  minimumUnitWeight: number;
  notReflectedFlg: number;
  internalMode: number;
  item: PantryPlateCorrectionInfo;
  battery: number;
  pantry: PantryPlatePantryInfo;
}

export interface PantryPlatePantryInfo {
  name: string;
  imageUrl: string;
}

// 食品提案API
export interface FoodRecommendationReasonContentItem {
  type: string | null;
  id: number | null;
  image: string | null;
  url: string | null;
}
export interface FoodRecommendationReasonItem {
  title: string;
  description: string;
  contents: Array<FoodRecommendationReasonContentItem>;
}
export interface FoodRecommendationListItem {
  foodId: number;
  name: string;
  image: string | null;
  icon: string | null;
  elapsedDays: number | null;
  reason: FoodRecommendationReasonItem;
}
export interface FoodRecommendationList {
  foods: Array<FoodRecommendationListItem>;
  recommendId: string;
  recommendTime: string;
  reason: FoodRecommendationReasonItem;
}
export class RequestFoodRecommendation {
  uncheckedId: number;
  constructor(uncheckedId: number) {
    this.uncheckedId = uncheckedId;
  }
}
// パントリー消費済み食材一覧取得
export interface PantryItemsConsumeFoodListItem {
  pantryId: number;
  pantryPlateId: number | null | undefined;
  pantryFridgeId: number | null | undefined;
  ingredientId: number;
  name: string;
  imageUrl: string | null | undefined;
}
export class PantryItemsConsumeFoodList {
  pantryList: Array<PantryItemsConsumeFoodListItem>;
  totalCount: number;
  start: number;
  constructor() {
    this.pantryList = [];
    this.totalCount = 0;
    this.start = 0;
  }
}

// 買い物リスト(スキャン・パントリー)の食材登録
export class RequestShoppingFoods {
  foods: Array<RequestShoppingFood>;
  constructor() {
    this.foods = [];
  }
}

export class RequestShoppingFood {
  foodId: number;
  name: string;
  constructor(foodId: number, name: string) {
    this.foodId = foodId;
    this.name = name;
  }
}

export class RecoginitionList {
  list: Array<FoodItem> | null;
  constructor() {
    this.list = null;
  }
}

export class IngredientList {
  list: Array<SelectingCandidateIngredientListDataItem> | null;
  constructor() {
    this.list = null;
  }
}

export interface FavoriteFoodStatus {
  done: boolean;
}

// パントリー：冷蔵庫食材判定
export interface FridgeItemsJudge {
  pantryJudgeKey: string;
  newCandidateItems: Array<FridgeJudgeCadidateItem>;
  pantryFridgeItems: Array<FridgeJudgeItem>;
  usedUpCandidateItems: Array<FridgeJudgeItem>;
  pantryItems: Array<FridgeJudgeItem>;
}

export interface FridgeJudgeCadidateItem {
  inferenceResultFoodId: number;
  applianceId: string;
  ingredientId: number;
  name: string;
  imageUrl: string;
  icon: string;
}

export interface FridgeJudgeItem {
  pantryId: number | null;
  pantryPlateId: number | null;
  pantryFridgeId: number | null;
  ingredientId: number;
  name: string;
  imageUrl: string;
  icon: string;
  purchaseDate: string;
}

export class FridgeItemsJudgeData {
  response: FridgeItemsJudge | null;
  constructor() {
    this.response = null;
  }
  isCamera() {
    let result = false;
    if (this.response != null && this.response.pantryJudgeKey != null) {
      result = true;
    }
    return result;
  }
  getNewCandidateItems(inferenceResultFoodId: number) {
    let result = null;
    if (this.response != null && this.response.newCandidateItems != null) {
      for (let i = 0; i < this.response.newCandidateItems.length; i++) {
        const item = this.response.newCandidateItems[i];
        if (item.inferenceResultFoodId == inferenceResultFoodId) {
          result = item;
          break;
        }
      }
    }
    return result;
  }
}

// パントリー：冷蔵庫食材確認
export class RequestFoodUpdate {
  confirm: RequestFridgeItemsConfirm | null;
  delete: DeletePantryInfo | null;
  ingredients: RegisterScanIngredients | null;
  constructor() {
    this.confirm = null;
    this.delete = null;
    this.ingredients = null;
  }
}

export class DetetePantryConfirmItem {
  pantryId: number | null;
  pantryPlateId: number | null;
  pantryFridgeId: number | null;
  foodStatus: number | null;
  constructor() {
    this.pantryId = null;
    this.pantryPlateId = null;
    this.pantryFridgeId = null;
    this.foodStatus = null;
  }
}

export class RequestFridgeItemsConfirm {
  pantryJudgeKey: string;
  confirmItems: Array<FridgeConfirmItem> | null;
  deleteItems: Array<FridgeDeleteItem> | null;
  deletePantryItems: Array<DetetePantryConfirmItem> | null;
  constructor(pantryJudgeKey: string) {
    this.pantryJudgeKey = pantryJudgeKey;
    this.confirmItems = null;
    this.deleteItems = null;
    this.deletePantryItems = null;
  }
}

export class FridgeConfirmItemInfo {
  foodId: number | null;
  item: FridgeConfirmItem;
  constructor(foodId: number | null, item: FridgeConfirmItem) {
    this.foodId = foodId;
    this.item = item;
  }
}
export class FridgeConfirmItem {
  inferenceResultFoodId: number;
  userFixIngredientId: number | null;
  userFixName: string | null;
  userIsNew: number;
  userSkipFlag: boolean;
  applianceId: string | null;
  expirationDays: number | null;
  constructor(
    inferenceResultFoodId: number,
    item: SaveFridgeFoodItem) {
    this.inferenceResultFoodId = inferenceResultFoodId;
    this.userFixIngredientId = null;
    this.userFixName = null;
    // 食材IDが選択されている場合(手入力でもIDあり)
    if (item.ingredientId != null && item.ingredientId != -1) {
      if (item.ingredientId != item.defaultIngredientId) {
        this.userFixIngredientId = item.ingredientId;
      }
    } else {
      this.userFixName = item.name;
    }
    this.userIsNew = item.userNew;
    this.userSkipFlag = item.isSkip;
    this.applianceId = item.applianceId;
    this.expirationDays = null;
  }
}

export class FridgeDeleteItem {
  pantryFridgeId: number;
  foodStatus: number | null;
  constructor(pantryFridgeId: number,
    foodStatus: number | null) {
    this.pantryFridgeId = pantryFridgeId;
    this.foodStatus = foodStatus;
  }
}

export class SelectingCandidateIngredientListDataItem extends SelectingIngredientListDataItem {
  foodId: number | null;
  applianceId: string | null;
  isSkip: boolean;
  defaultIngredientId: number | null;
  defaultName: string | null;
  userNew: number;
  constructor() {
    super();
    this.foodId = null;
    this.applianceId = null;
    this.isSkip = false;
    this.defaultIngredientId = null;
    this.defaultName = null;
    this.userNew = CONFIRM_USER_NEW.USER_NEW;
  }
}

export class SaveAddFoodItemData {
  fridgeItems: Array<SaveFridgeFoodItem> | null;
  purChasedItems: Array<SaveFoodItem> | null;
  rankingItems: Array<SaveFoodItem> | null;
  favoriteItems: Array<SaveFoodItem> | null;
  categoryItems: Array<SaveCategoryFoodItems> | null;
  constructor() {
    this.fridgeItems = null;
    this.favoriteItems = null;
    this.purChasedItems = null;
    this.rankingItems = null;
    this.categoryItems = null;
  }
  getFridgeItem(inferenceResultFoodId: number) {
    let result = null;
    if (this.fridgeItems != null) {
      for (const item of this.fridgeItems) {
        if (item.inferenceResultFoodId == inferenceResultFoodId) {
          result = item;
          break;
        }
      }
    }
    return result;
  }
  getPurChasedItem(ingredientId: number) {
    let result = null;
    if (this.purChasedItems != null) {
      for (const item of this.purChasedItems) {
        if (item.ingredientId == ingredientId) {
          result = item;
          break;
        }
      }
    }
    return result;
  }
  getRankingItem(ingredientId: number) {
    let result = null;
    if (this.rankingItems != null) {
      for (const item of this.rankingItems) {
        if (item.ingredientId == ingredientId) {
          result = item;
          break;
        }
      }
    }
    return result;
  }
  getFavoriteItem(ingredientId: number) {
    let result = null;
    if (this.favoriteItems != null) {
      for (const item of this.favoriteItems) {
        if (item.ingredientId == ingredientId) {
          result = item;
          break;
        }
      }
    }
    return result;
  }
  getCategoryFoodItem(category: string, genre: string, ingredientId: number) {
    let result = null;
    if (this.categoryItems != null) {
      for (const item of this.categoryItems) {
        result = item.getFoodItem(genre, ingredientId);
        if (result != null) {
          break;
        }
      }
    }
    return result;
  }
}

export class SaveFridgeFoodItem {
  inferenceResultFoodId: number | null;
  ingredientId: number | null;
  name: string;
  isSkip: boolean;
  isSelect: boolean;
  defaultIngredientId: number | null;
  defaultName: string | null;
  imageUrl: string;
  applianceId: string | null;
  userNew: number;
  constructor(
    item :SelectingCandidateIngredientListDataItem
  ) {
    this.inferenceResultFoodId = item.id;
    this.ingredientId = item.foodId;
    this.name = item.name;
    this.isSkip = item.isSkip;
    this.isSelect = item.isSelect;
    this.defaultIngredientId = item.defaultIngredientId;
    this.defaultName = item.defaultName;
    this.imageUrl = item.imageUrl;
    this.applianceId = item.applianceId;
    this.userNew = item.userNew;
  }
}

export class SaveFoodItem {
  ingredientId: number | null;
  name: string;
  constructor(
    item :SelectingIngredientListDataItem
  ) {
    this.ingredientId = item.id;
    this.name = item.name;
  }
}

export class SaveCategoryFoodItems {
  category: string;
  genreList: Array<SaveGenreFoodItems>;
  constructor(category: string,
    genreList: Array<SaveGenreFoodItems>) {
    this.category = category;
    this.genreList = genreList;
  }
  getFoodItem(genre: string, ingredientId: number) {
    let result = null;
    if (this.genreList != null) {
      for (const item of this.genreList) {
        if (item.genre == genre) {
          result = item.getFoodItem(ingredientId);
          if (result != null) {
            break;
          }
        }
      }
    }
    return result;
  }
}

export class SaveGenreFoodItems {
  genre: string;
  foodList: Array<SaveFoodItem>;
  constructor(genre: string,
    foodList: Array<SaveFoodItem>) {
    this.genre = genre;
    this.foodList = foodList;
  }
  getFoodItem(ingredientId: number) {
    let result = null;
    if (this.foodList != null) {
      for (const item of this.foodList) {
        if (item.ingredientId == ingredientId) {
          result = item;
          break;
        }
      }
    }
    return result;
  }
}

export class SaveDeleteFoodItemData {
  pantryItems: Array<SaveDeleteFoodItem> | null;
  pantryDeleteItems: Array<SaveDeleteFoodItem> | null;
  constructor() {
    this.pantryDeleteItems = null;
    this.pantryItems = null;
  }
  getPantyDeleteItem(id: number) {
    let result = null;
    if (this.pantryDeleteItems != null) {
      for (const item of this.pantryDeleteItems) {
        if (item.id == id) {
          result = item;
          break;
        }
      }
    }
    return result;
  }
  getPantyItem(id: number) {
    let result = null;
    if (this.pantryItems != null) {
      for (const item of this.pantryItems) {
        if (item.id == id) {
          result = item;
          break;
        }
      }
    }
    return result;
  }
}

export class SaveDeleteFoodItem {
  id: number;
  foodStatus: number;
  constructor(id: number, foodStatus: number) {
    this.id = id;
    this.foodStatus = foodStatus;
  }
}

export const CHECK_SCREEN_STATUS = {
  STATUS_NONE: 0,
  STATUS_API_EXEC: 1
};

export class StatusCameraCheck {
  id: number;
  inferenceResultFoodId: number;
  status: number;
  constructor(id: number, inferenceResultFoodId: number, status: number) {
    this.id = id;
    this.inferenceResultFoodId = inferenceResultFoodId;
    this.status = status;
  }
  isApiExec = () => {
    return (this.status == CHECK_SCREEN_STATUS.STATUS_API_EXEC);
  };
  clear = () => {
    this.id = -1;
    this.inferenceResultFoodId = DEFALT_FOOD_ID;
    this.status == CHECK_SCREEN_STATUS.STATUS_NONE;
  }
}

export class PantryCameraDateData {
  id: number;
  date: string;
  constructor(id: number, date: string) {
    this.id = id;
    this.date = date;
  }
}

export class PantryOpticalAxis {
  applianceId: string;
  correctionValue: number;
  constructor(applianceId: string, correctionValue: number) {
    this.applianceId = applianceId;
    this.correctionValue = correctionValue;
  }
}